// @flow
import getters from './getters'

import mutations from './mutations'
import actions from './actions'
import type { Module } from 'vuex'
import type { TlsProductsPage } from '../../../types/tls-products-page'

export type TlsProductState = {
  productsPage: ?TlsProductsPage,
  pageNumber: number,
  pageSize: number,
  orderBy: ?string,
  orderDirection: ?string
}
const initialState = (): TlsProductState => {
  return {
    productsPage: null,
    pageNumber: 0,
    pageSize: 10,
    orderBy: null,
    orderDirection: null
  }
}

export type TlsProductModule = Module<TlsProductState>

const module: TlsProductModule = {
  namespaced: true,
  state: initialState(),
  initialState: initialState(),
  getters,
  mutations,
  actions
}

export default module



// WEBPACK FOOTER //
// ./src/store/modules/tls-product/index.js